import { atom } from 'recoil';

/**
 * Log Files — lọc theo Tổ chức (header treeSelect + idBoPhan).
 * false (mặc định): ẩn treeSelect, hiện toàn bộ data BE trả về.
 * true: hiện treeSelect và lọc theo bộ phận đang chọn.
 * Có thể bật/tắt trên UI (Switch trên /logfiles/).
 *
 * Đổi default thành `true` nếu muốn luôn lọc theo tổ chức.
 */
export const LOGFILES_ORG_FILTER_DEFAULT = false;
export const LOGFILES_ORG_FILTER_STORAGE_KEY = 'logfiles-org-filter';

function loadOrgFilter(): boolean {
  if (typeof window === 'undefined') return LOGFILES_ORG_FILTER_DEFAULT;
  try {
    const raw = localStorage.getItem(LOGFILES_ORG_FILTER_STORAGE_KEY);
    if (raw === '1' || raw === 'true') return true;
    if (raw === '0' || raw === 'false') return false;
  } catch {
    /* ignore */
  }
  return LOGFILES_ORG_FILTER_DEFAULT;
}

export const logfilesOrgFilterEnabledState = atom<boolean>({
  key: 'logfilesOrgFilterEnabled',
  default: LOGFILES_ORG_FILTER_DEFAULT,
  effects: [
    ({ setSelf, onSet }) => {
      if (typeof window !== 'undefined') {
        setSelf(loadOrgFilter());
      }
      onSet((newValue) => {
        if (typeof window === 'undefined') return;
        try {
          localStorage.setItem(LOGFILES_ORG_FILTER_STORAGE_KEY, newValue ? '1' : '0');
        } catch (error) {
          console.error('Error saving logfiles org filter:', error);
        }
      });
    },
  ],
});
